"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedFilter = exports.transformLocationParam = exports.decodeFilters = exports.decodeFiltersValue = exports.encodeFilterValue = exports.SearchParamsBuilder = void 0;
var lists_1 = require("src/lists");
var SearchParamsBuilder = /** @class */ (function () {
    function SearchParamsBuilder() {
        var _this = this;
        this.searchParams = new URLSearchParams();
        this.Append = function (name, value, valueConverter) {
            if (valueConverter === void 0) { valueConverter = null; }
            if (value !== undefined) {
                if (valueConverter) {
                    value = valueConverter(value);
                }
                _this.searchParams.append(name, value);
            }
        };
        this.AppendArray = function (name, values, valueConverter) {
            if (valueConverter === void 0) { valueConverter = null; }
            if (values !== undefined) {
                if (valueConverter) {
                    values = values.map(valueConverter);
                }
                values.forEach(function (value) { return _this.Append(name, value); }); // no need to return any value
            }
        };
        this.toString = function () { return _this.searchParams.toString(); };
    }
    return SearchParamsBuilder;
}());
exports.SearchParamsBuilder = SearchParamsBuilder;
var encodeFilterValue = function (name, value, separator) {
    if (separator === void 0) { separator = ':'; }
    return "" + name + separator + encodeURIComponent(value);
};
exports.encodeFilterValue = encodeFilterValue;
var decodeFiltersValue = function (filters, separator) {
    if (separator === void 0) { separator = '='; }
    return filters
        ? filters.map(function (filterItem) {
            var _a = filterItem.split(separator), name = _a[0], value = _a[1];
            return "" + name + separator + decodeURIComponent(value);
        })
        : filters;
};
exports.decodeFiltersValue = decodeFiltersValue;
var decodeFilters = function (filters) {
    return filters
        ? filters.map(function (filterItem) {
            return decodeURIComponent(filterItem);
        })
        : filters;
};
exports.decodeFilters = decodeFilters;
var transformLocationParam = function (location) {
    var result = '';
    if (location) {
        result = Array.isArray(location) ? location.join(', ') : location;
    }
    return result;
};
exports.transformLocationParam = transformLocationParam;
var getSelectedFilter = function (selectedFilters, groupFilter, itemFilter) {
    if (itemFilter === void 0) { itemFilter = ''; }
    var values = Array.isArray(selectedFilters) ? selectedFilters : selectedFilters[groupFilter];
    return lists_1.getFirstOrDefault(values, '', function (itemValue) {
        var filterValue = exports.encodeFilterValue(groupFilter, itemFilter);
        if (itemFilter) {
            return itemValue === filterValue;
        }
        return itemValue.indexOf(filterValue) !== -1;
    });
};
exports.getSelectedFilter = getSelectedFilter;
